import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { getAllModelAPI, getSingleModelAPI } from "./model.api";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";

type IModelServiceProps = Omit<IGetAllServiceProps, "stage_id">;

const useAllModelService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: IModelServiceProps) => {
  const [searchModelQuery, setSearchModelQuery] = useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchModelQuery);
  const allModelService = useQuery({
    queryKey: [...CACHE_KEYS.MODEL, page, per_page, ...cacheKeys],
    queryFn: () =>
      getAllModelAPI({
        searchParams: {
          include: "motor_brand",
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchModelQuery, setSearchModelQuery },
    services: { allModelService },
  };
};

const useSingleModelService = ({
  singleModelId,
  enableQuery = true,
}: {
  singleModelId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.MODEL, singleModelId],
    queryFn: () => getSingleModelAPI(singleModelId),
    enabled: !!singleModelId && enableQuery,
  });
};

export { useAllModelService, useSingleModelService };
